/**
 * This file is auto-generated, please do not edit it manually.
 */
import * as React from 'react';
export function IcCancel(props) {
    return (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h24v24H0z" }),
            React.createElement("path", { d: "M12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10zm4.236 12.964a.899.899 0 11-1.272 1.272L12 13.273l-2.964 2.963a.898.898 0 01-1.272 0 .899.899 0 010-1.272L10.728 12 7.764 9.036a.899.899 0 111.272-1.272L12 10.728l2.964-2.964a.899.899 0 111.272 1.272L13.273 12l2.963 2.964z", fill: "currentColor" }))));
}
//# sourceMappingURL=IcCancel.js.map